const doc = [({"author":"ウェブアクセシビリティ基盤委員会（WAIC）", "pub_date":"2020年4月1日", "mod_date":"2024年**月**日"})];
module.exports = doc.length <= 1 ? doc[0] : doc;